import axios from "axios"

interface DappDetails {
    dappLogo: string;
    dappDomain: string;
    dappName:string;
}

interface details{
    dappLogo: string;
    dappDomain: string;
    dappName:string;
    triaName: any;
  }

const checkDidAvailability = async (name) => {
    try {
        const baseUrl = process.env.REACT_APP_BASE_URL
        const { data } = await axios.post(`${baseUrl}/api/v1/did/check`, {
            did: name?.toLowerCase() + "@tria"
        })
        console.log("did --->", data?.response?.availabilityStatus)
        return data?.response?.availabilityStatus
    } catch (err) {
        console.log(err)
    }

}

const getDidRecommendations = async (name) => {
    try {
        const baseUrl = process.env.REACT_APP_BASE_URL
        const { data } = await axios.get(`${baseUrl}/api/v2/get-name-recommendation?name=${name?.toLowerCase()}`)
        return data?.data[0]
    } catch (err) {
        console.log(err)
    }
}

const getDataFromLocalStorage = async () => {
    try {
        const dappData: DappDetails = JSON.parse(localStorage.getItem("dapp.details") || "{}") || { dappLogo: "", dappDomain: "" ,dappName:""};
        const triaName = JSON.parse(localStorage.getItem("tria.wallet.store") || "{}")?.triaName;
        // const localDetails = { triaName };

        const localDetails:details = { dappLogo: dappData.dappLogo, dappDomain: dappData.dappDomain,dappName:dappData?.dappName, triaName };

        return localDetails;
    } catch (error) {
        // Handle the error, log it, or return a default value
        console.error("Error retrieving local details:", error);
        return { dappLogo: "", dappDomain: "",dappName:"", triaName: "" }; // Default values or handle it based on your requirements
    }

}



function shortenWalletAddress(walletAddress: any, prefixLength = 6, suffixLength = 4) {
    if (typeof walletAddress !== 'string' || !walletAddress.startsWith('0x') || walletAddress.length < 42) {
        console.error('Invalid wallet address');
        return null;
    }

    const prefix = walletAddress.slice(0, prefixLength);
    const suffix = walletAddress.slice(-suffixLength);

    return `${prefix}...${suffix}`;
}

const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

export { checkDidAvailability, getDidRecommendations, getDataFromLocalStorage, shortenWalletAddress ,validateEmail}